import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { Landing, NotFound } from '..';
import Spinner from '../../../common/components/misc/Spinner';
import * as Cards from '../../cards';
import * as ContractsInvoices from '../../contractsinvoices';
import * as Events from '../../events';
import * as ExampleModule from '../../examplemodule';
import * as Maintenance from '../../maintenance';
import * as Offer from '../../offer';
import * as Profile from '../../profile';
import * as Subscription from '../../subscription';
import * as Tyre from '../../tyre';
import * as ValueAndCare from '../../valueandcare';
import * as ValueRepair from '../../valuerepair';
import HomeLayoutContainer, { HomeLayoutProps } from './containers/HomeLayoutContainer';

const HomeLayout: React.FC<{}> = (containerProps) => (
    <HomeLayoutContainer {...containerProps}>
        {(props: HomeLayoutProps) => (
            <Route
                render={() => {
                    if (!props.isReadyToRender) {
                        return (
                            <Spinner />
                        );
                    }

                    if (!props.policyConsentsAnswered) {
                        return <Redirect to={`${props.config.BaseURL}/policyconsents`} />;
                    }
                    return (
                        <React.Fragment>
                            {/* <SideNav /> */}
                            <Switch>
                                <Route exact path={[`${props.config.BaseURL}`, `${props.config.AlternativeBaseURL}`]} component={Landing} />
                                <Route path={[`${props.config.BaseURL}/examplemodule`, `${props.config.AlternativeBaseURL}/examplemodule`]} component={ExampleModule.ExampleModuleLayout} />
                                <Route path={[`${props.config.BaseURL}/profile`, `${props.config.AlternativeBaseURL}/profile`]} component={Profile.ProfileLayout} />
                                <Route path={[`${props.config.BaseURL}/valueandcare`, `${props.config.AlternativeBaseURL}/valueandcare`]} component={ValueAndCare.BaseLayout} />
                                <Route path={[`${props.config.BaseURL}/valuerepair`, `${props.config.AlternativeBaseURL}/valuerepair`]} component={ValueRepair.BaseLayout} />
                                <Route path={[`${props.config.BaseURL}/cards`, `${props.config.AlternativeBaseURL}/cards`]} component={Cards.CardsLayout} />
                                <Route path={[`${props.config.BaseURL}/contractsinvoices`, `${props.config.AlternativeBaseURL}/contractsinvoices`]} component={ContractsInvoices.BaseLayout} />
                                <Route path={[`${props.config.BaseURL}/maintenance`, `${props.config.AlternativeBaseURL}/maintenance`]} component={Maintenance.BaseLayout} />
                                <Route path={[`${props.config.BaseURL}/tyre`, `${props.config.AlternativeBaseURL}/tyre`]} component={Tyre.BaseLayout} />
                                <Route path={[`${props.config.BaseURL}/subscription_twonly`, `${props.config.AlternativeBaseURL}/subscription_twonly`]} component={Subscription.BaseLayout} />
                                <Route path={[`${props.config.BaseURL}/offers`, `${props.config.AlternativeBaseURL}/offers`]} component={Offer.BaseLayout} />
                                <Route path={[`${props.config.BaseURL}/events`, `${props.config.AlternativeBaseURL}/events`]} component={Events.BaseLayout} />
                                <Route component={NotFound} />
                            </Switch>

                        </React.Fragment>
                    );
                }}
            />)
        }
    </HomeLayoutContainer>
);

export default HomeLayout;
